import { useEffect, useState } from "react";
import { Grid, KpiCard } from "../../../../components";
import { MonitorFinanceiroService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";

const monitorFinanceiroService = new MonitorFinanceiroService();

const defaultKpis = {
  recebido: 0,
  pago: 0,
  saldoPeriodo: 0,
  receberAtraso: 0,
  pagarAtraso: 0,
  inadimplencia: 0,
  inadimplenciaPct: 0,
  saldoCaixas: 0,
  variacao: null,
};

function MonitorFinKpis({ filtrosBody }) {
  const [kpis, setKpis] = useState(defaultKpis);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    buscarKpis();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscarKpis() {
    setLoading(true);
    const result = await monitorFinanceiroService.getDashboardKpis(filtrosBody);
    if (!result.isAxiosError) {
      setKpis(result.data || defaultKpis);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const variacao = kpis.variacao || {};

  const cards = [
    {
      title: "Recebimentos no Período",
      value: formatPrice(kpis.recebido),
      icon: "ph-arrow-circle-down",
      color: "#1976d2",
      variation: variacao.recebido,
    },
    {
      title: "Pagamentos no Período",
      value: formatPrice(kpis.pago),
      icon: "ph-arrow-circle-up",
      color: "#d32f2f",
      variation: variacao.pago,
      invert: true,
    },
    {
      title: "Saldo no Período",
      value: formatPrice(kpis.saldoPeriodo),
      icon: "ph-currency-dollar",
      color: "#388e3c",
      variation: variacao.saldoPeriodo,
    },
    {
      title: "Contas a Receber em Atraso",
      value: formatPrice(kpis.receberAtraso),
      icon: "ph-receipt",
      color: "#f57c00",
      variation: variacao.receberAtraso,
      invert: true,
    },
    {
      title: "Contas a Pagar em Atraso",
      value: formatPrice(kpis.pagarAtraso),
      icon: "ph-credit-card",
      color: "#7b1fa2",
      variation: variacao.pagarAtraso,
      invert: true,
    },
    {
      title: "Valor de Inadimplência",
      value: formatPrice(kpis.inadimplencia),
      icon: "ph-warning-circle",
      color: "#d32f2f",
      variation: variacao.inadimplencia,
      invert: true,
    },
    {
      title: "Percentual de Inadimplência",
      value: `${(kpis.inadimplenciaPct || 0).toFixed(1).replace(".", ",")}%`,
      icon: "ph-percent",
      color: "#0288d1",
      variation: variacao.inadimplenciaPct,
      invert: true,
    },
    {
      title: "Saldo em Caixas/Contas",
      value: formatPrice(kpis.saldoCaixas),
      icon: "ph-bank",
      color: "#00796b",
      variation: variacao.saldoCaixas,
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 1 }}>
      {cards.map((card) => (
        <Grid key={card.title} item xs={6} md={3}>
          <KpiCard
            title={card.title}
            value={card.value}
            icon={card.icon}
            color={card.color}
            variation={card.variation}
            invert={card.invert}
            loading={loading}
          />
        </Grid>
      ))}
    </Grid>
  );
}

export default MonitorFinKpis;
